import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

import UserFeedbackLinks from '../common/_UserFeedbackLinks.jsx';

export default class CommunityExperts extends BLComponent 
{
	constructor (props, context) 
	{
		super(props, context);
		this.members = blapp.models.get('members')

		this.state = 
			{
				showHallOfFame: false
			};

		
	}

	render() 
	{
		
		return (
			<React.Fragment>
				<div className="main main--med l-margin-y--xl l-border-round overflow-hidden">
					<div className="main__content l-pad--null">
						<header className="l-pad--xl l-border-bottom l-flex l-split">
							<h1 className="text--xl-title">BrickLink Community Experts</h1>
						</header>
						{this.renderContents()}
						
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderContents()
	{
		return (
			[
				this.renderAdmins(this.members.adminGroups[90])
			,	this.renderAdmins(this.members.adminGroups[3])
			,	this.renderAdmins(this.members.adminGroups[5])
			,	this.renderAdmins(this.members.adminGroups[6])
			,	this.renderAdmins(this.members.adminGroups[4])
			,	this.renderAdmins(this.members.adminGroups[10])
			,	this.renderAdmins(this.members.adminGroups[8])
			,	this.renderHallOfFame()
			]
		)
	}

	renderHallOfFame() {
		
		return (
			<div className="bg-color--pewter community-experts__admin-section">
				<div className="l-pad--xl bg-color--white l-border-round base-formating base-formating--advanced">
					<div className="l-flex l-split l-margin-bottom--xl">
						<span className="community-experts__admin-title">Hall of Fame</span>
						<i className={"l-cursor-pointer fas " + ( (this.state.showHallOfFame )?"fa-caret-up":"fa-caret-down" )} onClick={()=>this.setState({showHallOfFame: !this.state.showHallOfFame})}></i>
					</div>
					<div className="community-experts__admin-type-description">
						Inactive or previous administrators that helped shape BrickLink into the site it is today.
					</div>

					{ (this.state.showHallOfFame)&& 
						this.renderHallOfFameDetail()}
					
				</div>
			</div>
		)
	}

	getHallOfFameAdminList(adminList) {
		return 	_.map( 
			adminList
		,	( admin, idx) =>
			{
				return(
					<div className="l-flex community-experts__admin-list">
						<span className="community-experts__width--25">&nbsp;</span>
						{admin.idUser > 0 ?
						<span className="community-experts__width--35"><UserFeedbackLinks username={admin.strUserName} feedbackScore={admin.nFeedback} aboutMe={admin.strAboutMe == 'Y'} /></span>
							:
						<span className="community-experts__width--35"><strong>{admin.strUserName}</strong></span>
						}
						<span className="community-experts__width--30">{blapp.format.formatDate(admin.dtStart)} - {blapp.format.formatDate(admin.dtEnd)}</span>
						{admin.idUser > 0 &&
						<span className="community-experts__width--10 text--right"><a href={"/contact.asp?u=" + admin.strUserName}><i className="fas fa-comment-lines community-experts__link"></i></a></span>
						}
					</div>
				)
			}
		);

	}

	renderHallOfFameDetail() {
		const adminTypeIDs = [ 
								{
									name : "communityOverseer"
								,	id: 9
								,	retired: true
								}
							,	
								{
									name : "catalogAdministrator"
								,	id: 90
								,	retired: false
								}
							,
								{
									name : "catalogAssociate"
								,	id: 3
								,	retired: false
								}
							,
								{
									name : "inventoryAdministrator"
								,	id: 5
								,	retired: false
								}
							,
								{
									name : "discussionsModerator"
								,	id: 6
								,	retired: false
								}
							,
								{
									name : "collageModerator"
								,	id: 4
								,	retired: false
								}
							,
								{
									name : "helpEditor"
								,	id: 7
								,	retired: true
								}
							,
								{
									name : "translatedHelpEditor"
								,	id: 8
								,	retired: false
								}
							];
		const hallOfFameContent = _.map(
				adminTypeIDs
			,	(adminType, idx) =>
				{
					const adminList = this.members.hallOfFame[adminType.id];
					const admin = this.getHallOfFameAdminList(adminList);
					const title = (adminType.name == "communityOverseer")?"Community Overseer":
								  (adminType.name == "catalogAdministrator")?"Catalog Administrator":
								  (adminType.name == "catalogAssociate")?"Catalog Associate":
								  (adminType.name == "inventoryAdministrator")?"Inventories Administrator":
								  (adminType.name == "discussionsModerator")?"Discussions Moderator":
								  (adminType.name == "collageModerator")?"Collage Moderator":
								  (adminType.name == "helpEditor")?"Help Editor":
								  (adminType.name == "translatedHelpEditor")?"Translated Help Editor":"";

					if (adminList != null && adminList.length > 0)
					{
						return(
							<div className="l-margin-bottom l-border--bottom community-experts__admin-type-description">
								<div className="l-flex" style={{height:"40px"}}>
									<span className="community-experts__width--25"><strong>{title}</strong>{adminType.retired && <div>(Position Retired)</div>}</span>
									<span className="community-experts__width--35"><strong>Username</strong></span>
									<span className="community-experts__width--30"><strong>Dates Active</strong></span>
									<span className="community-experts__width--10">&nbsp;</span>
								</div>
								{admin}
							</div>
						)
					}
				}
			)
		return (
			<div className="l-pad-top--xl l-border--top ">
				{hallOfFameContent}
			</div>
		)
	}

	renderAdmins(admin) {
		if (typeof admin != "undefined")
		{
			const typeId = admin.id;
			const adminList = admin.users;
			const admins =	_.map(
								adminList
							,	(admin, idx) =>
								{									
									if ( (typeId == 90) || (typeId == 3) || (typeId == 5) )
									{
										return(
											<div className="l-margin-bottom--xl" key={typeId + idx}>
												<div className="l-flex l-split l-margin-bottom l-center">
													<div className="l-flex l-center">
														<div className="l-margin-right community-experts__admin-profile-img">
															<span>
																<img className="community-experts__avatar-img l-vertical-align-middle" src={"https://www.bricklink.com" + admin.strAvatarImage}/>
															</span>
														</div>
														<div>
															<div className="l-margin-bottom"><UserFeedbackLinks username={admin.strUserName} feedbackScore={admin.nFeedback} aboutMe={admin.strAboutMe == 'Y'} /></div>
															<div><strong>Store</strong> <a href={ "https://store.bricklink.com/" + admin.strUserName + "?p=" + admin.strUserName + "#/terms"} >{admin.strStoreName}</a></div>
														</div>
													</div>
													<div>
														<div className="text--right l-margin-bottom"><a href={"/contact.asp?u=" + admin.strUserName}><i className="fas fa-comment-lines community-experts__link"></i></a></div>
														<div className="text--right"><strong>Active since</strong>: {blapp.format.formatDate(admin.dtActive)}</div>
													</div>
												</div>
												<div>
													{admin.strDescription}
												</div>
											</div>
										)
									}

									if ( (typeId == 6) || (typeId == 4) || (typeId == 10) ) 
									{
										return(
											<div className="l-margin-bottom--sm  l-border--bottom l-pad--bottom community-experts__admin-list-row--bottom-line" key={typeId + idx}>
												<div className="l-flex">
													<span className="community-experts__width--30"><UserFeedbackLinks username={admin.strUserName} feedbackScore={admin.nFeedback} aboutMe={admin.strAboutMe == 'Y'} /></span>
													<span className="community-experts__width--40"><a href={ "https://store.bricklink.com/" + admin.strUserName + "?p=" + admin.strUserName + "#/terms"} >{admin.strStoreName}</a></span>
													<span className="community-experts__width--20">{blapp.format.formatDate(admin.dtActive)}</span>
													<span className="community-experts__width--10 text--right"><a href={"/contact.asp?u=" + admin.strUserName}><i className="fas fa-comment-lines community-experts__link"></i></a></span>
												</div>
											</div>
										)
									}
									if (typeId == 8) 
									{
										return(
											<div className="l-margin-bottom--sm  l-border--bottom l-pad--bottom community-experts__admin-list-row--bottom-line" key={typeId + idx}>
												<div className="l-flex">
													<span className="community-experts__width--15"><img className="l-vertical-align-middle community-experts__country-flag" src ={blapp.url2.getCountryFlagUrl(admin.idCountry, 'S')}/> {admin.strLanguageName}</span>
													<span className="community-experts__width--30"><UserFeedbackLinks username={admin.strUserName} feedbackScore={admin.nFeedback} aboutMe={admin.strAboutMe == 'Y'} /></span>
													<span className="community-experts__width--30"><a href={ "https://store.bricklink.com/" + admin.strUserName + "?p=" + admin.strUserName + "#/terms"} >{admin.strStoreName}</a></span>
													<span className="community-experts__width--20">{blapp.format.formatDate(admin.dtActive)}</span>
													<span className="community-experts__width--5 text--right"><a href={"/contact.asp?u=" + admin.strUserName}><i className="fas fa-comment-lines community-experts__link"></i></a></span>
												</div>
											</div>
										)

									}
								}
							);
			return (
				<div className="bg-color--pewter community-experts__admin-section" key={admin.strName}>
					<div className="l-pad--xl bg-color--white l-border-round base-formating base-formating--advanced">
						<div className="l-flex l-split l-margin-bottom--xl">
							<span className="community-experts__admin-title">{admin.strName}</span>
							<button className="btn btn--tight btn--cta" onClick={()=>this.contact( admin.url )}>Contact team</button>
						</div>
						<div className="l-margin-bottom--xl l-border--bottom community-experts__admin-type-description">
							{ (typeId == 90) && <span>Verifies and approves new items, images, and relationships submissions. Adds, deletes and maintains items, categories, colors, relationships, images and their attributes in the catalog. Has auto-approval on new item additions, new relationship additions and image uploads. Verifies and approves new catalog inventories. Makes corrections to existing inventories by adding, deleting or adjusting items in inventories. Gives and revokes Registered Inventories Verifier status to and from other members. Has auto-approval on inventories additions. Can edit both <a href="/help.asp?topicID=21">Catalog</a> and <a href="/help.asp?topicID=38">Inventories</a> help topics.</span>}
							{ (typeId == 3) && <span>Verifies and approves new items, images, and relationships submissions. Adds, deletes and maintains items, categories, colors, relationships, images and their attributes in the catalog. Has auto-approval on new item additions, new relationship additions and image uploads. Can edit in <a href="/help.asp?topicID=21">Catalog help topics.</a></span>}
							{ (typeId == 5) && <span>Verifies and approves new catalog inventories. Makes corrections to existing inventories by adding, deleting or adjusting items in inventories. Gives and revokes Registered Inventories Verifier status to and from other members. Has auto-approval on inventories additions. Can edit <a href="/help.asp?topicID=38">Inventories help topics.</a></span>}
							{ (typeId == 6) && <span>The CEP Discussion Moderators can ban members from the discussion forum, lock threads, move messages posted in the discussion forum from one topic to another (E.g., move spam to the “Spam” topic), and edit <a href="/help.asp?topicID=23">Community help topics.</a></span>}
							{ (typeId == 4) && <span>Approves or rejects new images submitted by members to the Member Collage or new ID card images submitted by members for their ID card picture.</span>}
							{ (typeId == 10) && <span>Approves new links submissions. Adds, deletes and maintains links, link categories and their attributes in the links section. Has auto-approval on new links additions.</span>}
							{ (typeId == 8) && <span>Translates help topics, help categories and page text from English to another language. Applies changes made to help topics in English help center to matching help topics already translated to another language.</span>}
						</div>
						<div>
							{ ( (typeId == 6) || (typeId == 4) || (typeId == 10) ) &&

								<div className="l-flex l-margin-bottom">
									<span className="community-experts__width--30"><strong>Username</strong></span>
									<span className="community-experts__width--40"><strong>Store</strong></span>
									<span className="community-experts__width--20"><strong>Active Since</strong></span>
									<span className="community-experts__width--10">&nbsp;</span>
								</div>
							}

							{ (typeId == 8) &&
								<div className="l-flex l-margin-bottom">
									<span className="community-experts__width--15"><strong>Language</strong></span>
									<span className="community-experts__width--30"><strong>Username</strong></span>
									<span className="community-experts__width--30"><strong>Store</strong></span>
									<span className="community-experts__width--20"><strong>Active Since</strong></span>
									<span className="community-experts__width--5">&nbsp;</span>
								</div>
							}

							{admins}
						</div>
					</div>
					
				</div>
			)
		}
	}

	contact(url) {
		
		window.location.href  = url ;
	}

};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CommunityExperts blctx={{parent: null, idx:0}}  />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
